import React, { useEffect, useRef, useState } from "react";
import { Button, Spin, Modal, Typography , Popover} from "antd";
import { isEmpty, map , noop} from "lodash";
import moment from "moment";
import classNames from "classnames";

// import AddReminders from "@components/addReminder";
import Icon from "@assets/icon_config";
import { AddReminder, EditReminder, ListAllReminder } from "../../../constants/constants";
import { formatDisplayDate } from "@utils/helpers";
import "./remainder.scss";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";
import { CanEdit } from "@components/accessLevel";
import ReminderForm from "@components/reminder/reminderForm/reminderForm";
import { ADD, DELETE, EDIT, MEMBER_DETAILS_CARE_MANAGEMENT_TASKS } from "@utils/constants";
import DataNotFound from "@components/noDataFound";
import { NO_DATA_FOUND } from "../../../constants/constants";
import { EditAllRecurrence } from "../reminderForm/subComp";
import { useMemberListStore } from "@stores/useMemberListStore";

const NewReminder = ({
  listOfReminders,
  disabled,
  handleDelete,
  closePopOver,
  handleAdd,
  handleEdit,
  readonly = false,
  member = null,
  reminderOrigin,
  disableRecurrence = false,
  isReminderVisible = false,
  setIsReminderVisible = noop,
  actionVal = '',
  ReminderIcon
}: any) => {

  const [action, setAction] = useState(actionVal || ListAllReminder);
  const [reminderToBeEdited, setReminderToBeEdited] = useState({});
  switch (action) {
    case ListAllReminder:
      return (
        <Popover
          content={
            <ListAllReminderComponent
              setReminderToBeEdited={setReminderToBeEdited}
              disabled={disabled}
              listOfReminders={listOfReminders}
              setAction={setAction}
              closePopOver={closePopOver}
              handleDelete={handleDelete}
              readonly={readonly}
              reminderOrigin={reminderOrigin}
            />
          }
          trigger="click"
          placement="rightBottom"
          visible={isReminderVisible}
          overlayClassName="popover-with-no-padding"
        >
          {ReminderIcon ? <ReminderIcon reminders={listOfReminders}/> : <span className="reminderIcon pointer" onClick={() => setIsReminderVisible(!isReminderVisible)}>
            <Icon name={listOfReminders.filter((rem: any) => moment(rem.reminderEndDate) >= moment()).length > 0 ? "reminderWithNotification" : "reminderWithNoNotification"} height={22} width={22} />
          </span>}
        </Popover>
      );
    case AddReminder:
      return (
        <AddReminderComponent listOfReminders={listOfReminders} handleAdd={handleAdd} setAction={setAction} member={member} reminderOrigin={reminderOrigin} disableRecurrence={disableRecurrence} />
      );

    case EditReminder:
      return (
        <EditReminderComponent
          listOfReminders={listOfReminders}
          member={member}
          reminderToBeEdited={reminderToBeEdited}
          setAction={setAction}
          handleEdit={handleEdit}
          handleDelete={handleDelete}
          reminderOrigin={reminderOrigin}
          disableRecurrence={disableRecurrence}
        />
      );

    default:
      return <div>not having this action view Right now</div>;
  }
};

const ListAllReminderComponent = ({ disabled, listOfReminders, setAction, closePopOver, handleDelete, setReminderToBeEdited, readonly, reminderOrigin }: any) => {
  const sortRemainderData = (reminderData: any) => {
    reminderData.sort((a: any, b: any) => {
      return moment(formatDisplayDate(a.reminderStartDate, "reminderDateActualFormat", "reminderDateActualFormat", true)).format("YYYY-MM-DD HH:mm:ss") >
        moment(formatDisplayDate(b.reminderStartDate, "reminderDateActualFormat", "reminderDateActualFormat", true)).format("YYYY-MM-DD HH:mm:ss")
        ? 1
        : -1;
    });
    return reminderData;
  };

  // Commented this logic ( if disabling we were updating states to empty array, but as per requirement we need to delete only future reminders on task completion )
  // const filteredListOfReminders = disabled ? [] : sortRemainderData(listOfReminders);
  const filteredListOfReminders = sortRemainderData(listOfReminders);
  // commented this logic of upcoming reminders cz it is not needed for now
  // sortRemainderData(filter(listOfReminders, (rem: any) => moment(formatDisplayDate(rem.reminderEndDate , "reminderDateActualFormat" , "reminderDateActualFormat")) >= moment()));

  const firstUpcomingReminderRef = useRef<any>(null);

  useEffect(() => {
    console.log("ListAllReminderComponent.useEffect");
    if (firstUpcomingReminderRef.current) {
      firstUpcomingReminderRef.current.scrollIntoView({ block: "nearest" });
    }
  });

  let foundFirstUpcomingReminder = false;
  let foundPastReminder = false;

  return (
    <div className="ui-list-reminder">
      <div className="ui-list-reminder__header">
        <h3 className="f16 w600 ui-list-reminder__header__titleText">Reminders</h3>
        {!readonly && (
          <CanEdit>
            <Button
              className="f16 w500 "
              type="text"
              onClick={() => {
                setAction(AddReminder);
              }}
              title={"Add"}
              disabled={disabled}
            >
              <Icon name="add" height={"24"} width={"24"} />
            </Button>
          </CanEdit>
        )}
        <div onClick={() => closePopOver()} className="ui-list-reminder__header__close-popover">
          <Icon name={"close"} />
        </div>
      </div>
      {isEmpty(filteredListOfReminders) ? (
        <DataNotFound message={NO_DATA_FOUND} />
      ) : (
        <div className="ui-list-reminder__reminders">
          {map(filteredListOfReminders, (reminder) => {
            if (moment(formatDisplayDate(reminder.reminderEndDate, "reminderDateActualFormat", "reminderDateActualFormat", true)) >= moment() && foundFirstUpcomingReminder === false) {
              foundFirstUpcomingReminder = true;
              return (
                <div ref={firstUpcomingReminderRef}>
                  <div className="ui-list-reminder__reminders__upcoming-reminders">
                    <hr className="ui-list-reminder__reminders__upcoming-reminders__hr"></hr>
                    <span className="ui-list-reminder__reminders__upcoming-reminders__text">Current and Upcoming Reminders</span>
                    <hr className="ui-list-reminder__reminders__upcoming-reminders__hr"></hr>
                  </div>
                  <ReminderDetailCard
                    readonly={readonly}
                    reminder={reminder}
                    disabled={disabled}
                    setAction={setAction}
                    setReminderToBeEdited={setReminderToBeEdited}
                    handleDelete={handleDelete}
                    reminderOrigin={reminderOrigin}
                    filteredListOfReminders={filteredListOfReminders}
                  />
                </div>
              );
            } else {
              if (foundPastReminder === false && moment(formatDisplayDate(reminder.reminderEndDate, "reminderDateActualFormat", "reminderDateActualFormat", true)) <= moment()) {
                foundPastReminder = true;
                return (
                  <div>
                    <div className="ui-list-reminder__reminders__upcoming-reminders">
                      <hr className="ui-list-reminder__reminders__upcoming-reminders__hr"></hr>
                      <span className="ui-list-reminder__reminders__upcoming-reminders__text">Past Reminders</span>
                      <hr className="ui-list-reminder__reminders__upcoming-reminders__hr"></hr>
                    </div>
                    <ReminderDetailCard
                      readonly={readonly}
                      reminder={reminder}
                      disabled={disabled}
                      setAction={setAction}
                      setReminderToBeEdited={setReminderToBeEdited}
                      handleDelete={handleDelete}
                      reminderOrigin={reminderOrigin}
                      filteredListOfReminders={filteredListOfReminders}
                    />
                  </div>
                );
              }
              return (
                <ReminderDetailCard
                  readonly={readonly}
                  reminder={reminder}
                  disabled={disabled}
                  setAction={setAction}
                  setReminderToBeEdited={setReminderToBeEdited}
                  handleDelete={handleDelete}
                  reminderOrigin={reminderOrigin}
                  filteredListOfReminders={filteredListOfReminders}
                />
              );
            }
          })}
        </div>
      )}
    </div>
  );
};

const ReminderDetailCard = ({ reminder, disabled, setAction, setReminderToBeEdited, handleDelete, readonly, reminderOrigin, filteredListOfReminders }: any) => {
  const [isLoading, setIsLoading] = useState(false);
  const [deleteSeriesModalVisibility, setDeleteSeriesModalVisibility] = useState(false);

  const reminderToBeDeleted = useMemberListStore((state) => state.reminderToBeDeleted);
  const setReminderToBeDeleted = useMemberListStore((state) => state.setReminderToBeDeleted);

  const { Text } = Typography;
  const editIconClass = classNames("ui-list-reminder__reminder__timings__action__btn-icon icon-edit f18 clr-blueLink pointer", {
    disabled: disabled,
  });

  const deleteIconClass = classNames("ui-list-reminder__reminder__timings__action__btn-icon icon-delete f18 clr-e100 pointer", {
    disabled: disabled,
  });

  const disableOnDate = moment(formatDisplayDate(reminder.reminderStartDate, "reminderDateActualFormat", "reminderDateActualFormat", true)) > moment() ? true : false;

  // This disable code need to be made generic
  const disableEditBasedOnOriginOfReminders = () => {
    if (reminder?.reminderType === MEMBER_DETAILS_CARE_MANAGEMENT_TASKS) {
      return reminderOrigin === MEMBER_DETAILS_CARE_MANAGEMENT_TASKS;
    }
    return true;
  };
  return (
    <Spin spinning={isLoading} indicator={<HealthemSpinner />}>
      {deleteSeriesModalVisibility && reminderToBeDeleted?.reminderId === reminder?.reminderId &&
          <EditAllRecurrence metaDataKey={DELETE} toggleModal={setDeleteSeriesModalVisibility} onOk={({operationRange} : {operationRange : string}) => {
            setIsLoading(true);
            handleDelete({ toBeDeletedItem: reminder , loaderCallback : () => {
              setIsLoading(false);
            } , operationRange});
          }}/>
      }
      <div
        className={`ui-list-reminder__reminders__reminder ${
          moment(formatDisplayDate(reminder.reminderStartDate, "reminderDateActualFormat", "reminderDateActualFormat", true)) <= moment() ? "inActive-reminder" : ""
        }`}
        onClick={() => {
          if (!disabled) {
            setAction(EditReminder);
            setReminderToBeEdited(reminder);
          }
        }}
      >
        <div className="ui-list-reminder__reminders__reminder__timings">
          <p className="f14 ui-list-reminder__reminders__reminder__timings__timingData">
            {`${formatDisplayDate(reminder.reminderStartDate, "reminderDateActualFormat", "formatDateForReminder", true)} | 
              ${formatDisplayDate(reminder.reminderStartDate, "reminderDateActualFormat", "formatTimeForReminder", true)}`}{" "}
            {" to "}
            {formatDisplayDate(reminder.reminderEndDate, "reminderDateActualFormat", "formatTimeForReminder", true)}
          </p>
          {!readonly && (
            <CanEdit>
              <div className="ui-list-reminder__reminders__reminder__timings__action">
                {/* based on suggestion from simran and venkit edit icon is removed and the entire reminder card is made clickable
                <i
                  className={editIconClass}
                  onClick={() => {
                    if (!disabled) {
                      setAction(EditReminder);
                      setReminderToBeEdited(reminder);
                    }
                  }}
                /> */}
                {disableOnDate && 
                disableEditBasedOnOriginOfReminders() && (
                  <i
                    className={deleteIconClass}
                    onClick={(e) => {
                      e.stopPropagation();

                      if(reminder?.parentReminderId) {
                        setDeleteSeriesModalVisibility(true);
                        setReminderToBeDeleted(reminder);
                      } else {
                        setIsLoading(true);
                        handleDelete({ toBeDeletedItem: reminder , loaderCallback : () => {
                          setIsLoading(false);
                        }});
                      }
                    }}
                  />
                )}
              </div>
            </CanEdit>
          )}
        </div>
        <Text className="f16 ui-list-reminder__reminders__reminder__title" style={filteredListOfReminders?.length > 0 ? { width: 215 } : undefined} ellipsis={filteredListOfReminders?.length > 0 ? true : false}>
        {reminder.reminder}
        </Text>
      </div>
    </Spin>
  );
};

export const AddReminderComponent = ({ listOfReminders, handleAdd, setAction, member, reminderOrigin, disableRecurrence = false , closeForm , showSearch = false , allowClear = false}: any) => {
  const [isLoading, setIsLoading] = useState(false);

  const onAddAction = (reminder: any, loaderCallback: any) => {
    // setIsLoading(true);
    handleAdd(
      {
        toBeAdded: {
          from: reminder?.reminderStartDate,
          to: reminder?.reminderEndDate,
          titleVal: reminder?.description,
          recurrence: reminder?.recurrence,
          patientId : reminder?.patientId,
          patientName : reminder?.patientName,
          reminderTitle : reminder?.reminderTitle,
        },
      },
      () => {
        handleClose();
        setIsLoading(false);
        loaderCallback(false);
      }
    );
  };

  function handleClose() {
    if(closeForm) {
      closeForm();
      return;
    }
    setAction(ListAllReminder);
  }

  return (
    <Spin spinning={isLoading} indicator={<HealthemSpinner />}>
      <Modal open={true} footer={null} closable={false} className="reminderForm__modal-layout">
        <ReminderForm
          action={ADD}
          listOfReminders={listOfReminders}
          reminder={member}
          closeReminderForm={handleClose}
          showSearch={showSearch}
          allowClear={allowClear}
          addReminder={onAddAction}
          reminderOrigin={reminderOrigin}
          disableRecurrence={disableRecurrence}
        />
      </Modal>
    </Spin>
  );
};

export const EditReminderComponent = ({ listOfReminders, reminderToBeEdited, setAction, handleEdit, member, handleDelete, reminderOrigin, disableRecurrence = false , closeForm}: any) => {
  const [isLoading, setIsLoading] = useState(false);

  const onEditAction = (reminder: any, loaderCallback:any) => {
    // setIsLoading(true);
    handleEdit(
      {
        reminder,
      },
      () => {
        handleClose();
        setIsLoading(false);
        loaderCallback();
      }
    );
  };

  const onDeleteAction = (reminder: any ,  loaderCallback:any , operationRange : string) => {
    setIsLoading(true);
    handleDelete({ toBeDeletedItem: reminder , loaderCallback : () => {
      handleClose();
      setIsLoading(false);
      loaderCallback();
    }, operationRange});
  };
  
  function handleClose() {
    if(closeForm) {
      closeForm();
      return;
    }
    setAction(ListAllReminder);
  }

  return (
    <Spin spinning={isLoading} indicator={<HealthemSpinner />}>
      <Modal open={true} footer={null} closable={false} className="reminderForm__modal-layout">
        <ReminderForm
          action={EDIT}
          listOfReminders={listOfReminders}
          reminder={{ ...member, ...reminderToBeEdited }}
          closeReminderForm={handleClose}
          showSearch={false}
          allowClear={false}
          editReminder={onEditAction}
          deleteReminder={onDeleteAction}
          reminderOrigin={reminderOrigin}
          disableRecurrence={disableRecurrence}
        />
      </Modal>
    </Spin>
  );
};

export default NewReminder;
